<template>
  <div class="account-pages my-5 pt-sm-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="bg-soft-primary">
              <div class="row">
                <div class="col-12 " style="padding-right: 20px;padding-top: 20px">
                  <img src="/static/img/logo.png" alt="" class="img-fluid">
                </div>
              </div>
            </div>
            <div class="card-body pt-0">

              <div class="p-2">
                <div v-if="error" class="alert alert-danger" role="alert">
                  Неправильные данные авторизации
                </div>
                <form class="form-horizontal" action="/">

                  <div class="form-group">
                    <label for="name">Name</label>
                    <input type="text" class="form-control" v-model="login.name" id="name" placeholder="Name">
                  </div>

                  <div class="form-group">
                    <label for="userpassword">Password</label>
                    <input type="password" class="form-control" v-model="login.password" id="userpassword" placeholder="Password">
                  </div>

                  <div class="mt-3">
                    <button v-if="!loading" class="btn btn-primary btn-block waves-effect waves-light" style="color:white;" v-on:keyup.enter="loginUser" @click="loginUser" >Auth</button>
                    <button v-if="loading" type="button" class="btn btn-primary  btn-block waves-effect waves-light">
                      <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i> Auth
                    </button>
                  </div>

                </form>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      login: {
        name: '',
        password: ''
      },
      error: false,
      loading: false
    }
  },
  methods: {
    async loginUser () {
      try {
        this.loading = true
        let response = await this.$http.post('/user/login', this.login)
        let token = response.data.token
        localStorage.setItem('jwt', token)

        this.$http.defaults.headers['Authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        if (token) {
          let response = await this.$http.get('/user/me')
          localStorage.setItem('user', JSON.stringify(response.data))
          console.log('wtf')
          this.$user.data = response.data;
          this.$router.push("/licenses");
        }
      } catch (err) {
        this.error = true
        this.loading = false
        console.log('Error', 'Something Went Wrong', 'error')
        console.log(err.response)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue